import { authService } from '../apis/authService';
import { getMyProfile } from '../apis/userApiService';
import { shareInflight } from '../hooks/useSignedUrlRetry';

export const toAbsoluteAvatarUrl = (rawUrl) => {
  if (!rawUrl) return '';
  if (/^https?:\/\//i.test(rawUrl)) return rawUrl;
  const base = process.env.REACT_APP_API_URL || '';
  if (!base) return rawUrl;
  const normalizedBase = base.replace(/\/$/, '');
  const normalizedPath = String(rawUrl).replace(/^\/+/, '');
  if (!normalizedPath) return normalizedBase;
  return `${normalizedBase}/${normalizedPath}`;
};

// /auth/me payload (same shape as AuthContext's `currentUser`).
const pickAuthMeAvatar = (user) =>
  user?.profile?.profileImagePath || user?.profile?.profileimage || user?.profileImagePath || '';

/**
 * Refetch /auth/me and return the freshly signed avatar URL (Header, Session Manager).
 * Read-only: does not touch AuthContext, so the session/auth flow is unchanged.
 * Concurrent callers share a single request.
 */
export async function fetchAuthMeAvatarUrl() {
  const result = await shareInflight('avatar:auth-me', () => authService.getMe());
  return result?.success ? toAbsoluteAvatarUrl(pickAuthMeAvatar(result.data)) : '';
}

/**
 * Refetch /account/me and return the freshly signed avatar URL (Profile Settings).
 * Concurrent callers share a single request.
 */
export async function fetchAccountMeAvatarUrl() {
  const res = await shareInflight('avatar:account-me', () => getMyProfile());
  const root = res?.data;
  const profile = root?.profile ?? root?.data?.profile ?? root?.body?.data?.profile;
  return toAbsoluteAvatarUrl(profile?.profileimage || '');
}
